/**
 * Pure MUI colour mappers for the Tender Emails dialog (STD-014 split out of
 * TenderEmailsDialog.tsx). Kept side-effect-free so they can be unit-tested
 * directly.
 */

export function getEvaluationColor(
  evaluation: string | null
): 'success' | 'error' | 'warning' | 'default' {
  switch (evaluation) {
    case 'yes':
      return 'success';
    case 'no':
      return 'error';
    case 'maybe':
      return 'warning';
    default:
      return 'default';
  }
}

export function getStatusColor(
  status: string
): 'success' | 'error' | 'warning' | 'info' | 'default' {
  switch (status) {
    case 'completed':
      return 'success';
    case 'failed':
      return 'error';
    case 'processing':
      return 'info';
    case 'pending':
      return 'warning';
    default:
      return 'default';
  }
}
